class DlPageFoldSwipeX extends HTMLElement {
    connectedCallback() {
        if (this.accordionAbortController) return;
        this.accordionAbortController = new AbortController();
        this.swiperEl = this.querySelector('.dl-page-fold-swipe-X-swiper');
        this.navSwiperEl = this.querySelector('.dl-page-fold-swipe-X-nav-swiper'); // 添加这行
        this.navigationEl = this.querySelector('.dl-page-fold-swipe-X-navigation');
        this.navItems = this.querySelectorAll('.dl-page-fold-swipe-X-nav-item');
        this.mobileCards = this.querySelectorAll('.dl-page-fold-swipe-X-mobile-card'); // 手机手风琴

        this.currentIndex = 0;
        this.navIndicatorRaf = null;
        this.initSwiper();
        this.initNavSwiper();
        this.setupMobileAccordion(); // 新增：初始化手机端手风琴
        this.addResizeListener();
    }

    // 计算spaceBetween的方法
    calculateSpaceBetween() {
        if (window.innerWidth <= 990) {
            return (8 / 375) * window.innerWidth;
        } else if (window.innerWidth <= 1600) {
            return (24 / 1600) * window.innerWidth;
        } else if (window.innerWidth >= 1920) {
            return (24 / 1920) * window.innerWidth;
        } else {
            return 24;
        }
    }
    // 导航Swiper的spaceBetween计算方法
    calculateNavSpaceBetween() {
        if (window.innerWidth <= 990) {
            return 0; // 手机端直接返回
        } else if (window.innerWidth <= 1600) {
            return (40 / 1600) * window.innerWidth;
        } else if (window.innerWidth >= 1920) {
            return (40 / 1920) * window.innerWidth;
        } else {
            return 40;
        }
    }

    initSwiper() {
        if (typeof Swiper === 'undefined') {
            this.swiperRetry = setTimeout(() => this.initSwiper(), 100);
            return;
        }

        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: this.calculateSpaceBetween(),
            loop: false,
            resistance: true,
            resistanceRatio: 0.85,
            on: {
                slideChange: (swiper) => {
                    this.currentIndex = swiper.activeIndex;
                    this.updateNavigation(swiper.activeIndex);
                    this.updateNavIndicator(swiper.activeIndex);
                    // this.updateNavSwiperPosition(swiper.activeIndex); // 添加这行
                },
                init: (swiper) => {
                    this.updateNavigation(0);
                    this.updateNavIndicator(0, { immediate: true });
                }
            }
        });

        this.setupNavigation();
        this.updateNavIndicator(this.currentIndex, { immediate: true });
    }

    // 添加导航Swiper初始化方法
    initNavSwiper() {
        if (typeof Swiper === 'undefined') {
            this.navSwiperRetry = setTimeout(() => this.initNavSwiper(), 100);
            return;
        }

        this.navSwiper = new Swiper(this.navSwiperEl, {
            spaceBetween: this.calculateNavSpaceBetween(),
            slidesPerView: 'auto',      // 每个slide宽度自适应
            freeMode: true,              // 支持自由拖动
            freeModeMomentum: false, // 禁用动量滚动
            freeModeSticky: false,
            navigation: {
                nextEl: this.querySelector('.dl-page-fold-swipe-X-nav-button-next'),
                prevEl: this.querySelector('.dl-page-fold-swipe-X-nav-button-prev'),
            }
        });

        this.navSwiper.on('setTranslate', () => {
            this.updateNavIndicator(this.currentIndex, { immediate: true });
        });

        this.navSwiper.on('resize', () => {
            this.updateNavIndicator(this.currentIndex, { immediate: true });
        });

    }

    setupNavigation() {
        this.navItems.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateNavIndicator(index);
                this.goToSlide(index);
            }, { signal: this.accordionAbortController.signal });

            item.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.updateNavIndicator(index);
                    this.goToSlide(index);
                }
            }, { signal: this.accordionAbortController.signal });
        });
    }

    goToSlide(index) {
        if (this.swiper && index !== this.currentIndex) {
            this.updateNavIndicator(index);
            this.swiper.slideTo(index);
        }
    }

    updateNavigation(activeIndex) {
        this.navItems.forEach((item, index) => {
            item.classList.toggle('dl-selected', index === activeIndex); // 保持dl-selected类名
            item.setAttribute('aria-selected', index === activeIndex);
        });
    }

    updateNavIndicator(activeIndex, options = {}) {
        if (!this.navigationEl) return;

        const activeItem = this.navItems[activeIndex];
        if (!activeItem) return;

        const { immediate = false } = options;

        const run = () => {
            const navRect = this.navigationEl.getBoundingClientRect();
            const itemRect = activeItem.getBoundingClientRect();

            const offset = itemRect.left - navRect.left;
            const width = itemRect.width;

            this.navigationEl.style.setProperty('--nav-indicator-x', `${offset}px`);
            this.navigationEl.style.setProperty('--nav-indicator-w', `${width}px`);
        };

        if (immediate) {
            run();
            return;
        }

        if (this.navIndicatorRaf) {
            cancelAnimationFrame(this.navIndicatorRaf);
        }

        this.navIndicatorRaf = requestAnimationFrame(run);
    }

    // // 添加导航Swiper位置更新方法
    // updateNavSwiperPosition(activeIndex) {
    //     if (!this.navSwiper) return;

    //     const activeSlide = this.navSwiper.slides[activeIndex];
    //     if (activeSlide) {
    //         const slideOffset = activeSlide.offsetLeft;
    //         const slideWidth = activeSlide.offsetWidth;
    //         const swiperWidth = this.navSwiper.width;

    //         if (slideOffset < this.navSwiper.translate ||
    //             slideOffset + slideWidth > this.navSwiper.translate + swiperWidth) {
    //             this.navSwiper.slideTo(activeIndex);
    //         }
    //     }
    // }

    addResizeListener() {
        this.boundResize = () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.handleResize(), 100);
        };
        window.addEventListener('resize', this.boundResize);
    }

    handleResize() {
        this.updateMobileCardHeights();
        if (this.swiper) {
            this.swiper.params.spaceBetween = this.calculateSpaceBetween();
            this.swiper.update();
        }
        if (this.navSwiper) {
            this.navSwiper.params.spaceBetween = this.calculateNavSpaceBetween();
            this.navSwiper.update();
        }
        this.updateNavIndicator(this.currentIndex);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.boundResize);
        clearTimeout(this.resizeTimer);
        clearTimeout(this.swiperRetry);
        clearTimeout(this.navSwiperRetry);
        this.cardResizeObserver?.disconnect();
        this.cancelCardSettled?.();
        this.accordionAbortController?.abort();
        this.accordionAbortController = null;
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        if (this.navSwiper) {
            this.navSwiper.destroy(true, true);
        }
        if (this.navIndicatorRaf) {
            cancelAnimationFrame(this.navIndicatorRaf);
            this.navIndicatorRaf = null;
        }
    }

    // ===== 新增：手机手风琴功能 =====
    setupMobileAccordion() {
        if (!this.mobileCards.length) return;

        // Hidden desktop cards have no measurable title height. Observe them again
        // when the accordion becomes visible or its font/width changes.
        this.cardResizeObserver = new ResizeObserver(() => this.updateMobileCardHeights());
        this.mobileCards.forEach(card => {
            const title = card.querySelector('.dl-page-fold-swipe-X-mobile-card-title');
            if (title) this.cardResizeObserver.observe(title);
        });
        this.updateMobileCardHeights();

        this.mobileCards.forEach((card, index) => {
            // const icon = card.querySelector('.dl-page-fold-swipe-X-mobile-card-title-icon');

            const toggleCard = () => {
                this.cancelCardSettled?.();
                const isOpen = card.classList.contains('dl-open');
                const shouldScroll = window.innerWidth <= 990;
                const cardIndex = Number(card.dataset.cardIndex ?? index);

                const currentlyOpenCard = Array.from(this.mobileCards).find(c => c.classList.contains('dl-open'));
                const currentOpenIndex = currentlyOpenCard
                    ? Number(currentlyOpenCard.dataset.cardIndex ?? Array.from(this.mobileCards).indexOf(currentlyOpenCard))
                    : -1;
                const shouldPerformScroll = shouldScroll && cardIndex > currentOpenIndex;

                // 收起所有
                this.mobileCards.forEach(c => c.classList.remove('dl-open'));

                // 如果之前是关闭状态，则展开当前
                if (!isOpen) {
                    card.classList.add('dl-open');
                    if (shouldPerformScroll) {
                        this.waitForMobileCardSettled(card, () => {
                            if (card.classList.contains('dl-open') && this.shouldScrollCardTitle(card)) {
                                this.scrollMobileCardIntoView(card);
                            }
                        });
                    }
                }
                this.mobileCards.forEach(c => {
                    c.querySelector('.dl-page-fold-swipe-X-mobile-card-title')
                        ?.setAttribute('aria-expanded', String(c.classList.contains('dl-open')));
                });
            };
            card.addEventListener('click', toggleCard, { signal: this.accordionAbortController.signal });
            const title = card.querySelector('.dl-page-fold-swipe-X-mobile-card-title');
            title?.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleCard();
                }
            }, { signal: this.accordionAbortController.signal });
        });
    }

    scrollMobileCardIntoView(card) {
        const topBarHeight = this.getTopBarHeight();
        const scrollOffset = topBarHeight + 8;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const rect = card.getBoundingClientRect();
                const absoluteTop = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
                const target = Math.max(absoluteTop - scrollOffset, 0);

                window.scrollTo({
                    top: target,
                    behavior: 'smooth'
                });
            });
        });
    }

    shouldScrollCardTitle(card) {
        const title = card.querySelector('.dl-page-fold-swipe-X-mobile-card-title');
        if (!title) return true;

        const topBarHeight = this.getTopBarHeight();
        const scrollOffset = topBarHeight + 8;
        const rect = title.getBoundingClientRect();

        return rect.top < scrollOffset;
    }

    waitForMobileCardSettled(card, callback) {
        let timeoutId = null;

        const cleanup = () => {
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            card.removeEventListener('transitionend', handleTransitionEnd);
        };

        const handleTransitionEnd = (event) => {
            if (event.target !== card || event.propertyName !== 'max-height') {
                return;
            }
            cleanup();
            requestAnimationFrame(() => {
                callback();
            });
        };

        this.cancelCardSettled = cleanup;
        card.addEventListener('transitionend', handleTransitionEnd);

        timeoutId = setTimeout(() => {
            cleanup();
            callback();
        }, 300);
    }

    getTopBarHeight() {
        const topBar = document.querySelector('dl-page-topbar-x');
        if (!topBar) return 0;

        const styles = window.getComputedStyle(topBar);
        const isSticky = ['fixed', 'sticky'].includes(styles.position);
        const rect = topBar.getBoundingClientRect();

        return isSticky ? rect.height : rect.top > 0 ? rect.bottom : rect.height;
    }


    updateMobileCardHeights() {
        this.mobileCards.forEach(card => {
            const title = card.querySelector('.dl-page-fold-swipe-X-mobile-card-title');
            if (!title || !title.getClientRects().length) return;
            const content = card.querySelector('.dl-page-fold-swipe-X-mobile-card-content');
            const inset = parseFloat(getComputedStyle(content).top) || 0;
            // Measure only the title, without removing max-height mid-transition.
            const height = Math.ceil(title.getBoundingClientRect().height + inset * 2);
            card.style.setProperty('--collapsed-height', `${height}px`);
        });
    }

}

// 确保只定义一次
if (!customElements.get('dl-page-fold-swipe-x')) {
    customElements.define('dl-page-fold-swipe-x', DlPageFoldSwipeX);
}